//#region IMPORT
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
/** Components */
import 'dayjs/locale/ko';
import useDelete from '../../../../hooks/useDeleteN';
import { useSearch1, useDelete1, useSave1 } from './NOT_BASIC_02_QUERY';
/** Icons Import */
import NOT_BASIC_02 from './NOT_BASIC_02';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import { useSave } from '../../../../hooks/useSaveN';
import useFileUpload from '../../../../hooks/useFileUpload';
import { NOT_BASIC_02_Schema } from './NOT_BASIC_02_Schema';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import useFcmHandler from '../../../../hooks/useFcmHandler';
//#endregion

//#region 상수
// 화면 MENU_ID
const SCREEN_MENU_ID = 'NoticeBoard';
const NOT_BASIC_02_FCM_GUBUN_NEW = 'AL_003_001';
const NOT_BASIC_02_FCM_GUBUN_UPDATE = 'AL_003_002';
const FCM_BULK_CHUNK = 100;
//#endregion

//#region FCM (사업장 전체)
const IsNotBasic02SaveRowSuccess = (saveDetailData, idx, changedLen) => {
  const row = saveDetailData?.[idx];
  if (row?.isSuccess === true || row?.IsSuccess === true) return true;
  if (
    changedLen === 1 &&
    saveDetailData?.length === 1 &&
    (row?.isSuccess === true || row?.IsSuccess === true)
  ) {
    return true;
  }
  return false;
};

const FetchSiteMembersForNotBasic02Fcm = async ({ userInfo, searchInfo }) => {
  const custCd = searchInfo?.custCd || userInfo?.custCd || '';
  if (!custCd) return [];

  const coCd =
    userInfo?.authCd === 'ADMIN'
      ? searchInfo?.coCd || userInfo?.coCd || ''
      : userInfo?.coCd || '';

  const params = {
    UserId: userInfo?.userid,
    AuthCd: Commons.EncryptAES(userInfo?.authCd || ''),
    CoCd: Commons.EncryptAES(coCd),
    CustCd: Commons.EncryptAES(custCd),
    SearchText: Commons.EncryptAES(''),
  };

  const data = await apiRequest(
    'post',
    Global.urls.Member.getMemBasicR1,
    params
  );
  const rows = Array.isArray(data)
    ? data
    : Array.isArray(data?.data)
      ? data.data
      : [];
  const requesterId = String(userInfo?.userid || '').trim();

  return rows.filter((m) => {
    const useYn = String(m.useYn ?? m.UseYn ?? 'Y').toUpperCase();
    if (useYn !== 'Y') return false;
    const id = String(m.id ?? m.ID ?? m.userId ?? '').trim();
    return id && id !== requesterId;
  });
};

const SendNotBasic02FcmToSiteMembers = async ({
  sendFcm,
  changedRows,
  saveDetailData,
  userInfo,
  searchInfo,
  dispatch,
}) => {
  if (!sendFcm?.bulk) return;
  const detail = saveDetailData ?? [];
  const changedLen = changedRows?.length ?? 0;
  if (!changedLen || !dispatch) return;

  const custCd = searchInfo?.custCd || userInfo?.custCd || '';
  if (!custCd) {
    dispatch(
      showSnackbar({
        message: '사업장이 선택되지 않아 알림을 보낼 수 없습니다.',
        type: 'warning',
      })
    );
    return;
  }

  let members = [];
  try {
    members = await FetchSiteMembersForNotBasic02Fcm({ userInfo, searchInfo });
  } catch (e) {
    console.error('[NOT_BASIC_02] 사업장 인력 조회 실패:', e);
    return;
  }

  if (!members.length) return;

  const targetUserIds = members
    .map((m) => String(m.id ?? m.ID ?? m.userId ?? '').trim())
    .filter(Boolean);

  if (!targetUserIds.length) return;

  try {
    for (let idx = 0; idx < changedRows.length; idx++) {
      const row = changedRows[idx];
      if (!IsNotBasic02SaveRowSuccess(detail, idx, changedLen)) continue;

      const saved = detail[idx] || {};
      const chaebun =
        saved.chaebun ?? saved.Chaebun ?? row.chaebun ?? row.Chaebun ?? '';
      const noticeTitle = String(row.title ?? '').trim();
      const isUpdate = Boolean(String(row.chaebun ?? '').trim());
      const body =
        noticeTitle ||
        (isUpdate
          ? '공지 내용이 수정되었습니다.'
          : '새 공지가 등록되었습니다.');

      await sendFcm.bulk({
        targetUserIds,
        title: isUpdate ? '공지사항 수정' : '공지사항',
        body,
        codeGroup: isUpdate
          ? NOT_BASIC_02_FCM_GUBUN_UPDATE
          : NOT_BASIC_02_FCM_GUBUN_NEW,
        route: chaebun ? `/M_Notice/detail/${chaebun}` : '/M_Notice',
        responseData: String(chaebun),
        chunkSize: FCM_BULK_CHUNK,
      });
    }
  } catch (e) {
    console.error('[NOT_BASIC_02] FCM 전송 오류:', e);
    dispatch(
      showSnackbar({
        message: e?.message || '알림 전송에 실패했습니다.',
        type: 'warning',
      })
    );
  }
};
//#endregion

function NOT_BASIC_02F(props) {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  const sendFcm = useFcmHandler();
  const gridRef1 = useRef(); // 작업계획서

  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);
  //#endregion

  //#region 커스텀훅
  const { SaveLogicPreview, SaveLogicFile, DeleteLogicFile } = useFileUpload({
    oldFilePathField: 'filePath',
    newFileNameField: 'saveName',
    getTargetPath: (item, custCd) => {
      const coCd =
        userInfo.authCd === 'ADMIN' ? searchInfo.coCd : userInfo.coCd;
      return `NoticeBoard/${coCd}/NOT_BASIC_02`;
    },
  });
  // 부분 갱신 처리 (성공한 데이터만 재조회, 실패한 데이터는 유지)
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.chaebun,
    getKeyFromResult: (result) => result.chaebun,
  });
  //#endregion

  //#region useEffect
  // 버튼 로직
  useEffect(() => {
    if (props.filterClick2) {
      gridRef1.current.api &&
        gridRef1.current.api.setQuickFilter(searchInfo.searchText || '');
      props.setFilterClick2(false);
    }
    if (props.saveClick2) {
      Save1();
      props.setSaveClick2(false);
    }
  }, [props.filterClick2, props.saveClick2, searchInfo.searchText]);
  //#endregion

  //#region 쿼리
  // 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows);
    },
  });
  const SearchLogic1 = async () => {
    ResetLogic();
    await Search1();
  };

  // 삭제
  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  // 저장
  const { runAsync: Save1Async } = useSave1();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '파일 업로드',
    schema: NOT_BASIC_02_Schema,
    getChangedRows: () => changedRowData1.filter((r) => !r.deleteYn),
    getDeletedRows: () => deletedRowData1,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: (rows) => Save1Async(rows),
    fileSave: SaveLogicFile,
    fileDelete: DeleteLogicFile,
    onSuccessRefresh: async ({ saveDetailData, changedRows }) => {
      const rows = changedRows || [];
      const hasFailure = (saveDetailData ?? []).some(
        (r) => r?.isSuccess === false || r?.IsSuccess === false
      );

      if (hasFailure) {
        await handlePartialRefresh({
          saveResult: saveDetailData,
          changedRows: rows,
          searchLogic: SearchLogic1,
        });
      } else {
        ResetLogic();
        await Search1();
      }

      const savedCount = rows.filter((_, idx) =>
        IsNotBasic02SaveRowSuccess(saveDetailData, idx, rows.length)
      ).length;
      if (savedCount > 0) {
        void SendNotBasic02FcmToSiteMembers({
          sendFcm,
          changedRows: rows,
          saveDetailData,
          userInfo,
          searchInfo,
          dispatch,
        });
      }
    },
  });

  // 초기화
  const ResetLogic = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };
  //#endregion

  //#region 나머지 함수
  // 파일 다운로드
  const DownloadLogic2 = async (_data) => {
    if (_data.newYn === 'Y') {
      dispatch(
        showSnackbar({
          message: '저장 후 파일 다운로드가 가능합니다.',
          type: 'warning',
        })
      );
      return;
    }

    if (!_data.filePath) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const filePath = fixUrl(_data.filePath);
      const fileName = _data.fileName || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 1) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 2) <a> 태그 만들어서 클릭 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 저장될 파일명
        document.body.appendChild(a);
        a.click();

        // 3) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return ''; // 또는 적절한 fallback
    const parts = url.split('/');
    const fileName = parts.pop(); // 파일 이름 분리
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };
  //#endregion

  return (
    <div className="wrap">
      <NOT_BASIC_02
        gridId1={'grid1'}
        navigate={navigate}
        userInfo={userInfo}
        rowData1={rowData1}
        lanInfo={lanInfo}
        gridRef1={gridRef1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        selectedRowNosRef1={selectedRowNosRef1}
        deletedRowData1={deletedRowData1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        // 함수
        SearchLogic1={SearchLogic1}
        SaveLogicPreview={SaveLogicPreview}
        DownloadLogic2={DownloadLogic2}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection1={handleRowSelection1}
        RestoreRow1={deleteHandler1.RestoreRow}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
      />
    </div>
  );
}

export default NOT_BASIC_02F;
